import React from 'react';
import './ListFilters.scss';

const TextFilter = React.forwardRef(({ value, setValue }: {[index: string]: any}, ref: any) => {
	return (
		<div className='ListFilter TextFilter'>
			<input ref={ref} type='text' value={value} onChange={e => setValue(e.target.value)} />
		</div>
	);
});

export default TextFilter;
